import React from "react";
import Navbar from "../Components/Navbar/Navbar";

const Contact = () => {
  return (
    <div>
    <Navbar/>
      <div>I am Contact</div>
    </div>
  );
};

export default Contact;
